<div class="filter-container" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <edt-filter-header
    [countActiveFilters]="selectedDate !== null ? 1 : 0"
    [filterName]="title"
    (openFilter)="toggleOpen($event)"
  ></edt-filter-header>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
    cdkConnectedOverlayWidth="300"
    (overlayOutsideClick)="close()"
  >
    <div class="filter-menu">
      <div class="row align-items-start">
        <div class="col-12 my-4">
          <mat-form-field>
            <mat-label>Nueva fecha</mat-label>
            <input
              matInput
              [matDatepicker]="picker"
              [(ngModel)]="selectedDate"
              (dateChange)="changeDate($event)"
            />
            <mat-hint>dd/MM/YYYY</mat-hint>
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-12">
          <mat-form-field>
            <mat-label>Filtro</mat-label>
            <mat-select
              [(value)]="keys[0]"
              [(ngModel)]="selectedFilter"
              (selectionChange)="changeSelectionFilter()"
            >
              @for (key of keys; track key) {
              <mat-option [value]="key">{{
                filterOptions[key]!.label
              }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        @if (!!selectedDate) {
        <div class="col-12 my-2 text-end">
          <button class="me-2" mat-button (click)="clear()">
            Borrar selección
          </button>
        </div>
        }
      </div>
    </div>
  </ng-template>
</div>
